/* eslint-env browser */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupStore } from './store/configureStore';
import Table from './components/Table';

const store = setupStore();
const rootElement = document.querySelector('.data-table');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
  <StrictMode>
    <Provider store={store}>
      <Table />
    </Provider>
  </StrictMode>,
);
